import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.5625 15.6C12.5915 17.725 14.3098 19.4389 16.4375 20.4625C16.5944 20.5368 16.768 20.569 16.9412 20.5558C17.1143 20.5427 17.2811 20.4847 17.425 20.3875L20.55 18.3C20.6881 18.2064 20.8476 18.1492 21.0137 18.1339C21.1799 18.1186 21.3472 18.1457 21.5 18.2125L27.35 20.725C27.5499 20.8082 27.717 20.9549 27.8254 21.1423C27.9338 21.3298 27.9776 21.5477 27.95 21.7625C27.7646 23.2097 27.0582 24.5397 25.9631 25.5037C24.8679 26.4677 23.459 26.9997 22 27C17.4913 27 13.1673 25.2089 9.97919 22.0208C6.79107 18.8327 5 14.5087 5 10C5.00033 8.54101 5.53227 7.13211 6.49628 6.03696C7.4603 4.9418 8.79033 4.23543 10.2375 4.05001C10.4523 4.02242 10.6702 4.0662 10.8577 4.17462C11.0452 4.28304 11.1918 4.45007 11.275 4.65001L13.7875 10.5125C13.8528 10.6629 13.8802 10.8271 13.8671 10.9906C13.854 11.1541 13.8009 11.3119 13.7125 11.45L11.625 14.625C11.5321 14.7686 11.4775 14.9337 11.4666 15.1044C11.4556 15.2751 11.4887 15.4457 11.5625 15.6V15.6Z",
      stroke: "#152443",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }